import React from "react";
import { AlertTriangle, LogOut, RefreshCw, ShieldCheck } from "lucide-react";
import { Button, Spinner } from "../ui/primitives";
import { LogoFull } from "../Logo";

const COPY = {
  loading: {
    title: "Verifying platform access",
    detail: "Checking your current role and capabilities before loading platform data.",
  },
  denied: {
    title: "Platform access denied",
    detail: "Your account does not have permission to open this platform area.",
  },
  unavailable: {
    title: "Could not verify platform access",
    detail: "No platform data was loaded. Check your connection, then try the access check again.",
  },
};

export default function PlatformAccessState({
  kind = "loading",
  detail,
  onRetry,
  onSignOut,
  onBack,
}) {
  const copy = COPY[kind] || COPY.unavailable;
  const isLoading = kind === "loading";
  const Icon = kind === "denied" ? ShieldCheck : AlertTriangle;

  return (
    <div className="min-h-screen bg-muted px-4 py-10 grid place-items-center" data-testid={`platform-access-${kind}`}>
      <main className="w-full max-w-lg rounded-2xl border border-line bg-surface p-6 sm:p-8 shadow-card text-center">
        <div className="flex justify-center mb-6"><LogoFull height={34} /></div>
        <div className="mx-auto mb-4 w-12 h-12 rounded-xl bg-primary/10 text-primary grid place-items-center">
          {isLoading ? <Spinner className="w-6 h-6" /> : <Icon className="w-6 h-6" aria-hidden="true" />}
        </div>
        <h1 className="font-heading text-xl font-semibold text-ink">{copy.title}</h1>
        <p className="mt-2 text-sm leading-6 text-ink-subtle" aria-live="polite">
          {detail || copy.detail}
        </p>
        {!isLoading && (
          <div className="mt-6 flex flex-wrap justify-center gap-2">
            {onRetry ? (
              <Button type="button" onClick={onRetry} data-testid="platform-access-retry">
                <RefreshCw className="w-4 h-4" aria-hidden="true" /> Try again
              </Button>
            ) : null}
            {onBack ? <Button type="button" variant="outline" onClick={onBack}>Back to console</Button> : null}
            {onSignOut ? (
              <Button type="button" variant="ghost" onClick={onSignOut}>
                <LogOut className="w-4 h-4" aria-hidden="true" /> Sign out
              </Button>
            ) : null}
          </div>
        )}
      </main>
    </div>
  );
}
